export default "__VITE_ASSET__Dwgy22BX__"